import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";
import { format } from "date-fns";
import {
  Curve,
  ChevronRightArrow,
  WinnersIcon,
} from "../../../components/svgs";
import {
  Body,
  Button,
  Children,
  CurveHolder,
  DynamicButton,
  MainHolder,
  StyledText,
} from "../../../components/common/basic";

import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";
import { mashupRewardItems } from "./data";
import { BackButton } from "../../../components/common";
import useMashupNWinPoints from "./hooks/useMashupnWinPoints";

const MashupnWinPoints = () => {
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "MashupAndWinPoints",
        firebase_screen_class: "MashupAndWinPoints",
      })
    );
  }, []);

  const {
    background,
    history,
    userPoints,
    mashupnWinOrders,
    mashupRecentHistory,
    unitPoints,
  } = useMashupNWinPoints();

  return (
    <>
      <MainHolder>
        <Children style={{ background: "#f2f2f2" }}>
          <BackButton
            onClick={() => {
              history.goBack();
            }}
          />
          <Header background={background}>
            <div style={{ textAlign: "center" }}>
              <StyledText
                style={{ fontFamily: "MTNRegular" }}
                size={48}
                margin='0'
                color='white'
              >
                {parseFloat(userPoints).toLocaleString()}
              </StyledText>
              <StyledText
                size={8}
                margin='0'
                color='white'
                style={{ fontFamily: "MTNRegular" }}
              >
                GHc 0.1 = 5 points
              </StyledText>
              <Button
                style={{
                  margin: "10px 0 5px 0",
                  padding: "5px 6px",
                  display: "inline-block",
                }}
                onClick={() => {
                  history.push("/mashupnwin/leaderboard");
                }}
                color={"white"}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <WinnersIcon width={13} />
                  <StyledText
                    size={12}
                    style={{
                      margin: "2px 0 0 0",
                      padding: "0 5px",
                      fontFamily: "MTNRegular",
                    }}
                    color={"black"}
                  >
                    {"Leaderboard"}
                  </StyledText>
                  <ChevronRightArrow fill={"#000"} width={8} />
                </div>
              </Button>
            </div>
          </Header>
          <CurveHolder style={{ zIndex: 1, position: "relative" }}>
            <Curve fill={"#F2F2F2"} />
          </CurveHolder>
          <Body>
            <div style={{ boxSizing: "border-box", padding: "0 15px" }}>
              <MashupRewards
                items={mashupRewardItems}
                background={background}
                unitPoints={unitPoints}
                handleItemClick={(itemId) => {
                  history.push(`/mashupnwin/pickup/${itemId}`);
                }}
              />
              {mashupnWinOrders && mashupnWinOrders.length > 0 && (
                <div style={{ marginBottom: "40px" }}>
                  <DynamicButton
                    label='View Orders'
                    color={background}
                    onClick={() => {
                      history.push("/mashupnwin/orders");
                    }}
                  />
                </div>
              )}
              <MashupRecentCard items={mashupRecentHistory} />
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const MashupPointsItem = ({ amount, date, points }) => (
  <div
    style={{
      boxShadow: "0 5px 8px rgba(0,0,0,0.2)",
      marginBottom: "10px",
      borderRadius: "15px",
      overflow: "hidden",
      background: "#fff",
    }}
  >
    <div style={{ display: "flex", alignItems: "center" }}>
      <div
        style={{ flexGrow: 1, boxSizing: "border-box", padding: "10px 20px" }}
      >
        <StyledText
          size={13}
          style={{ fontFamily: "MTNMedium", margin: "0 0 3px 0" }}
        >
          GHS {amount} Mashup
        </StyledText>
        <StyledText style={{ fontFamily: "MTNRegular", margin: 0 }} size={11}>
          {date ? format(date, "PPP") : ""}
        </StyledText>
      </div>
      <PointsCard>{points} pts</PointsCard>
    </div>
  </div>
);

const MashupRewards = ({ items, background, handleItemClick, unitPoints }) => {
  return (
    <RewardWrapper>
      <StyledText
        size={20}
        style={{ fontFamily: "MTNMedium", margin: "0 0 20px 0" }}
      >{`Rewards to Redeem`}</StyledText>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          justifyItems: "center",
        }}
      >
        {items.map((item) => (
          <MashupRewardItem
            handleItemClick={handleItemClick}
            {...item}
            key={item.name}
            unitPoints={unitPoints}
            background={background}
          />
        ))}
      </div>
    </RewardWrapper>
  );
};

const MashupRewardItem = ({
  image,
  name,
  id,
  amount,
  background,
  unitPoints,
  handleItemClick,
}) => {
  return (
    <div
      onClick={() => handleItemClick(id)}
      style={{
        width: "180px",
        maxWidth: "48%",
        background: "#fff",
        borderRadius: "10px",
        overflow: "hidden",
        paddingBottom: "5px",
        marginBottom: "20px",
      }}
    >
      <div>
        <img style={{ width: "100%" }} src={image} />
      </div>
      <CurveHolder
        style={{ zIndex: 1, position: "relative", margin: "-20px 0px 0px" }}
      >
        <Curve height={24} fill={"white"} />
      </CurveHolder>
      <div style={{ textAlign: "center", padding: "0 10px 8px 10px" }}>
        <StyledText size={14} style={{ margin: "0 0 2px 0" }}>
          {name}
        </StyledText>
        <StyledText color={background} style={{ margin: 0 }} size={10}>
          <span style={{ color: "#000" }}>GHc{amount}</span> |{" "}
          <span style={{ fontFamily: "MTNMedium" }}>
            {amount * unitPoints} points
          </span>
        </StyledText>
      </div>
    </div>
  );
};

const MashupRecentCard = ({ items }) => {
  return (
    <>
      <StyledText
        size={20}
        style={{ fontFamily: "MTNMedium", margin: "0 0 20px 0" }}
      >{`My Recent Points`}</StyledText>
      {items.map((item, idx) => (
        <MashupPointsItem key={idx} {...item} />
      ))}
    </>
  );
};

const RewardWrapper = styled.div`
  margin-bottom: 30px;
`;

const PointsCard = styled.div`
  width: 100px;
  box-sizing: border-box;
  padding: 20px;
  color: #fff;
  font-family: MTNBold;
  background: #00678f;
  text-align: center;
`;

const Header = styled.div`
  /* width: 360px; */
  overflow: hidden;
  padding: 20px 20px 30px 20px;
  background-color: ${({ background }) => background};
  position: relative;
`;

export default MashupnWinPoints;
